import React from 'react';
import registeredComponent from '../../utils/registeredComponent';
import { duckify, singleDuck } from "../../utils/duckify";
import { billingContactForm, billingContacts, modals } from '../../ducks';
import FinancialSplitModal from './FinancialSplitModal';

const FinancialSplit = (
  {
    allPayerContacts,
    billingContact,
    billingContactId,
    contactId,
    payerContactId,
    schoolYearId,
    showModal
  }) => <a href='#' onClick={() => showModal(billingContact)}>
  {Number(currentSplit(billingContact, contactId, schoolYearId, payerContactId))}%
</a>;

const currentSplit = (billingContact, contactId, schoolYearId, payerContactId) => {
  const payer = billingContact && billingContact.billing_payers && billingContact.billing_payers.find(
    (payer) => payer.payer_contact.id === payerContactId
  ) || null;

  return payer ? payer.percent : 0;
};

const mapDucksToProps = (ownProps, state) => ({
  billingContact:
    state &&
    state.billingFinancialSplit.contacts[ownProps.contactId] &&
    state.billingFinancialSplit.contacts[ownProps.contactId][ownProps.schoolYearId]
      ? singleDuck(billingContacts, state.billingFinancialSplit.contacts[ownProps.contactId][ownProps.schoolYearId])
      : undefined
});

const mapStateToProps = (state) => ({
  ...state.billingContactForm
});

const mapDispatchToProps = (dispatch, props) => ({
  showModal: (billingContact) => {
    const {
      allPayerContacts,
      contactId,
      schoolYearId
    } = props;

    dispatch(billingContactForm.actions.load(
      buildModel(contactId, schoolYearId, allPayerContacts, billingContact)
    ));

    dispatch(
      modals.actions.show('FinancialSplitModal', {
        contactId: contactId,
        schoolYearId: schoolYearId,
        allPayerContacts: allPayerContacts
      })
    )
  }
});

export default registeredComponent("FinancialSplit")(
  duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FinancialSplit)
);

export const buildModel = (contactId, schoolYearId, payerContacts, billingContact) => {
  if (billingContact) {
    // If we have an existing BillingContact, construct list of potential
    // BillingPayers, not just those for which a value currently exists
    const payerIdsWithValues = billingContact.billing_payers.map((bp) => bp.payer_contact.id);
    const allPayerIds = Object.keys(payerContacts);
    const differenceIds = allPayerIds.filter(x => !payerIdsWithValues.includes(x));
    const differences = differenceIds.map((d) => ({...payerContacts[d], percent: 0}));

    return {
      ...billingContact,
      billing_payers: billingContact.billing_payers.concat(differences)
    };
  } else {
    return {
      contact_id: contactId,
      school_year_id: schoolYearId,
      billing_payers: Object.values(payerContacts).map(
        (payerContact) => ({...payerContact, percent: 0, id: Math.random()})
      )
    }
  }
};